export default {
    queryClasstreePageForBackAdd: {
        // 查询模块管理列表
        method: "post",
        // url: "web/rs/classtree/queryClasstreePageForBackAdd.json",
        url: "web/content/cmsBusContentCon/queryGoodsCategory.json",
        type: 'x-www-form',
        result_type: 'no_status' // 如果返回的只是json数据请配置这个字段与值
      },
}